import { Injectable } from "@angular/core";
import { LocalService } from "../services/local.service";
import { GeneralService } from './general.service';

@Injectable({
  providedIn: "root",
})
export class AllLocalStorageService {
  llave_sesion_id = "Lmsjn4720Jhur729";
  llave_url_volver = "KAMDJfjdd2843jmtl";
  llave_data_pago = "LAMjnfj2802kMjB09";
  llave_datos_cliente = "LmJSNFK28HnLbu";
  llave_asientos_ida = "KAJfnfp983hJBuy8";
  llave_asientos_vuelta = "HNjNodB8658VFT92";
  llave_viaje_ida = "HnFUir2984bf8v4";
  llave_busqueda_ida = "HnFIufas2984bf8v";
  llave_busqueda_vuelta = "P076vNbfdkHKjs";
  llave_viaje_vuelta = "P054vNbfdkHDFd";
  llave_historial_viaje_ida = "LmjhIUBiub977883B";
  llave_medios_pago = "Md1dfda1";
  constructor(private localService: LocalService, private generalService: GeneralService) { }

  // url volver (pageseat)
  obtenerUrlVolver(complemento) {
    let key = `${this.llave_url_volver}-${complemento}`;
    let data = this.localService.getJsonValue(key);
    return data;
  }

  guardarUrlVolver(data, complemento) {
    let key = `${this.llave_url_volver}-${complemento}`;
    let marca = this.generalService.obtenerMarcaDeTiempo();
    localStorage.setItem("m_u_v", marca);
    this.localService.setJsonValue(key, data);
  }

  eliminarUrlVolver(complemento) {
    let key = `${this.llave_url_volver}-${complemento}`;
    this.localService.clearToken(key);
  }

  // data pago
  guardarDataPAgo(data, complemento) {
    let key = `${this.llave_data_pago}-${complemento}`;
    let marca = this.generalService.obtenerMarcaDeTiempo();
    localStorage.setItem("m_d_p", marca);
    this.localService.setJsonValue(key, data);
  }

  obtenerDataPago(complemento) {
    let key = `${this.llave_data_pago}-${complemento}`;
    let data = this.localService.getJsonValue(key);
    return data;
  }

  eliminarDataPago(complemento) {
    let key = `${this.llave_data_pago}-${complemento}`;
    this.localService.clearToken(key);
  }

  // datos cliente pago
  obtenerDatosClientePAgo(complemento) {
    let key = `${this.llave_datos_cliente}-${complemento}`;
    let data = this.localService.getJsonValue(key);
    return data;
  }

  guardarDatosClientePago(data, complemento) {
    let key = `${this.llave_datos_cliente}-${complemento}`;
    let marca = this.generalService.obtenerMarcaDeTiempo();
    localStorage.setItem("m_d_c_p", marca);
    this.localService.setJsonValue(key, data);
  }

  eliminarDatosClientePago(complemento) {
    let key = `${this.llave_datos_cliente}-${complemento}`;
    this.localService.clearToken(key);
  }

  // Sesion id
  guardarSesionID(data, complemento) {
    let key = `${this.llave_sesion_id}-${complemento}`;
    let marca = this.generalService.obtenerMarcaDeTiempo();
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem("m_s_i", marca);
      this.localService.setJsonValue(key, data);
    }
  }

  obtenerSesionID(complemento) {
    let key = `${this.llave_sesion_id}-${complemento}`;
    let data = this.localService.getJsonValue(key);
    return data;
  }

  eliminarSesionID(complemento) {
    let key = `${this.llave_sesion_id}-${complemento}`;
    this.localService.clearToken(key);
  }

  // data asientos
  obtenerAsietnosIda(complemento) {
    let key = `${this.llave_asientos_ida}-${complemento}`;
    let data = this.localService.getJsonValue(key);
    return data;
  }

  guardarAsientosIda(data, complemento) {
    let key = `${this.llave_asientos_ida}-${complemento}`;
    if (data.length > 0) {
      let marca = this.generalService.obtenerMarcaDeTiempo();
      localStorage.setItem("m_a_i", marca);
      this.localService.setJsonValue(key, data);
    }
  }

  eliminarAsientosIda(complemento) {
    let key = `${this.llave_asientos_ida}-${complemento}`;
    this.localService.clearToken(key);
  }

  obtenerAsientosVuelta(complemento) {
    let key = `${this.llave_asientos_vuelta}-${complemento}`;
    let data = this.localService.getJsonValue(key);
    return data;
  }

  guardarAsientosVuelta(data, complemento) {
    let key = `${this.llave_asientos_vuelta}-${complemento}`;
    let marca = this.generalService.obtenerMarcaDeTiempo();
    localStorage.setItem("m_a_v", marca);
    this.localService.setJsonValue(key, data);
  }

  eliminarAsientosVuelta(complemento) {
    let key = `${this.llave_asientos_vuelta}-${complemento}`;
    this.localService.clearToken(key);
  }

  // viaje ida
  guardarViajeIda(data, complemento) {
    let key = `${this.llave_viaje_ida}-${complemento}`;
    let marca = this.generalService.obtenerMarcaDeTiempo();
    localStorage.setItem("m_v_i", marca);
    this.localService.setJsonValue(key, data);
  }

  // busqueda ida
  guardarBusquedaIda(data, complemento) {
    let key = `${this.llave_busqueda_ida}-${complemento}`;
    let marca = this.generalService.obtenerMarcaDeTiempo();
    localStorage.setItem("m_v_i", marca);
    this.localService.setJsonValue(key, data);
  }

  // busqueda regreso
  guardarBusquedaReg(data, complemento) {
    let key = `${this.llave_busqueda_vuelta}-${complemento}`;
    let marca = this.generalService.obtenerMarcaDeTiempo();
    localStorage.setItem("m_v_i", marca);
    this.localService.setJsonValue(key, data);
  }

  obtenerBusquedaIda(complemento) {
    let key = `${this.llave_busqueda_ida}-${complemento}`;
    let data = this.localService.getJsonValue(key);
    return data;
  }

  obtenerBusquedaReg(complemento) {
    let key = `${this.llave_busqueda_vuelta}-${complemento}`;
    let data = this.localService.getJsonValue(key);
    return data;
  }

  eliminarBusquedaReg(complemento) {
    let key = `${this.llave_busqueda_vuelta}-${complemento}`;
    this.localService.clearToken(key);
  }

  obtenerViajeIda(complemento) {
    let key = `${this.llave_viaje_ida}-${complemento}`;
    let data = this.localService.getJsonValue(key);
    return data;
  }

  eliminarViajeIda(complemento) {
    let key = `${this.llave_viaje_ida}-${complemento}`;
    this.localService.clearToken(key);
  }

  guardarViajeVuelta(data, complemento) {
    let key = `${this.llave_viaje_vuelta}-${complemento}`;
    let marca = this.generalService.obtenerMarcaDeTiempo();
    localStorage.setItem("m_v_v", marca);
    this.localService.setJsonValue(key, data);
  }

  obtenerViajeVuelta(complemento) {
    let key = `${this.llave_viaje_vuelta}-${complemento}`;
    let data = this.localService.getJsonValue(key);
    return data;
  }

  eliminarViajeVuelta(complemento) {
    let key = `${this.llave_viaje_vuelta}-${complemento}`;
    this.localService.clearToken(key);
  }

  // historial viaje ida
  obtenerHistorialViajeIda(complemento) {
    let key = `${this.llave_historial_viaje_ida}-${complemento}`;
    let data = this.localService.getJsonValue(key);
    return data;
  }

  guardarHistorialViajeIda(data, complemento) {
    let key = `${this.llave_historial_viaje_ida}-${complemento}`;
    let marca = this.generalService.obtenerMarcaDeTiempo();
    localStorage.setItem("m_h_v_i", marca);
    this.localService.setJsonValue(key, data);
  }

  eliminarHistorialViajeIda(complemento) {
    let key = `${this.llave_historial_viaje_ida}-${complemento}`;
    this.localService.clearToken(key);
  }

  obtenerTiempoCompra(key) {
    let data = this.localService.getJsonValue(key);
    return data;
  }

  guardarMediosPagos(data, complemento) {
    let key = `${this.llave_medios_pago}-${complemento}`;
    this.localService.setJsonValue(key, data);
  }

  obtenerMediosPago(complemento) {
    let key = `${this.llave_medios_pago}-${complemento}`;
    let data = this.localService.getJsonValue(key);
    return data;
  }

  eliminarMediosPago(complemento) {
    let key = `${this.llave_medios_pago}-${complemento}`;
    this.localService.clearToken(key);
  }
}
